import React from 'react'
import './StaticDiagram.less'
function StaticDiagram({ data: { sublist = [] } }) {
    const url = sublist[0].imageUrl
    return (
        <div className={'staticDiagramStyle'}>
            <img src={url} alt='' />
        </div>
    )
}

export default StaticDiagram
